// extracted by mini-css-extract-plugin
export default {"container":"styles__container___BT4Bk mixins__clearfix___YpR0o","heading":"styles__heading___NMKyR","availability":"styles__availability___VNivg","price":"styles__price___FdT-C"};